import React from "react";
import {
	Link
} from "react-router-dom";
import config from './../../config.js';
import Loading from './../../../components/loading.js';
import Aside from './../common/aside.js';

import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
	style: {
		top: '45px',
		right: 0
	}
}, (n) => notification = n);

export default class CreateReportT1 extends React.Component {
	constructor(props) {
		super(props);
		//console.log(props);
		let user = {};

		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
		}

		const pagetitle = '创建全脑分割报告 ';
		this.state = {
			page_title: pagetitle,
			user: user,
			projectid: props.match.params.projectid,
			taskid: props.match.params.taskid,
			tid: props.match.params.tid,
			project: '',
			creator: '',
			loading: true,
			roilist: [],
			checkedrois: [],
			checkedtheme: 'SkyBlue'
		}

		document.title = pagetitle;
		this.goback = this.goback.bind(this);

		this.actionSubmit = this.actionSubmit.bind(this);

	}


	componentDidMount() {
		this.getProject();
		this.onInitial(this.props);
	}


	componentWillReceiveProps(nextProps) {
		//this.onInitial(nextProps);
	}

	notify(message) {
		notification.notice({
			content: <span>{message}</span>,
			duration: 4,
			style: {
				'bottom': 0,
				'right': 0
			}
		});
	}

	goback() { //console/myprojects/project/service_list/76/brainlabel
		const me = this;
		//me.props.history.push('/console/myprojects/project/service_list/' + me.state.projectid + '/brainlabel');
		this.props.history.goBack(1);
	}

	/**
	 * fetch all brain label names
	 * @param  {[type]} data [description]
	 * @return {[type]}      [description]
	 */
	onInitial(data) {
		//console.log(data)
		const me = this;
		const {
			user
		} = me.state;
		const {
			projectid,
			taskid,
			tid
		} = data.match.params;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			taskid: taskid,
			brainlabelid: tid,
			request: 'create_report',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					me.setState({
						roilist: json.data,
						loading: false
					});

				} else {
					me.setState({
						roilist: [],
						loading: false
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}


	getProject() {
		const me = this;

		let {
			projectid,
			user
		} = me.state;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			Authorization: localStorage.token,
			request: 'project'
		};
		fetch(config.host + '/project/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					const data = json.data;
					me.setState({
						project: data.project,
						creator: data.creator
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}


	checkroi(key) {
		const me = this;
		let {
			checkedrois
		} = me.state;

		var index = checkedrois.indexOf(key);
		if (index !== -1) {
			checkedrois.splice(index, 1);
		} else {
			checkedrois.push(key);
		}
		console.log(checkedrois)
		me.setState({
			checkedrois: checkedrois
		})
	}


	changetheme(e) {
		console.log(e.target.value)
		this.setState({
			checkedtheme: e.target.value
		});
	}


	/**
	 * create and generate report
	 * @return {[type]} [description]
	 */
	actionSubmit() {
		const me = this;
		let {
			user,
			projectid,
			taskid,
			tid,
			roilist,
			checkedrois,
			checkedtheme
		} = me.state;

		if (!checkedrois.length || !roilist.length || checkedtheme == '') {
			me.notify('请先选择需要生成的脑区 ');
			return;
		}

		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			taskid: taskid,
			brainlabelid: tid,
			checkedrois: checkedrois,
			checkedtheme: checkedtheme,
			request: 'generate_report',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		me.notify('正在生成，请稍候... ');
		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);

				me.notify(json.message);
				if (json.status === 1) {
					me.setState({
						checkedrois: []
					});
					me.props.history.push('/console/t1/list_report/' + projectid + '/' + taskid + '/' + tid);
				}

				me.setState({
					loading: false
				});

			})
			.catch(function (error) {
				console.log(error);
			});

	}


	render() {
		const me = this;
		const {
			creator,
			user,
			projectid,
			project,
			page_title,
			roilist
		} = me.state;

		return (

			<div className="row">
				<Loading display={me.state.loading} />
				<div className="col-10">
					<nav className="animated fadeInDown">
						<ol className="breadcrumb pb-0 px-0">
							<li className="breadcrumb-item">
								<a onClick={() => me.goback()} ><strong><i className="fa fa-chevron-left"></i> 返回全脑分割</strong></a>
							</li>
							{projectid > 0 &&
								<li className="breadcrumb-item">
									<Link className="text-dark " to={`/console/myprojects/project/${projectid}/MR`}><strong> {project.name}</strong></Link>
								</li>
							}
							{projectid > 0 &&
								<li className="breadcrumb-item active">
									创建者: {creator.realname || creator.email || creator.title || creator.address || creator.office}
								</li>
							}
							<li className="breadcrumb-item " aria-current="page">{page_title}</li>
						</ol>
					</nav>
					<div className="clearfix py-3 ">
						<h4 className="float-left">创建报告</h4>
						<div className="float-right">
							<div className="input-group  input-group-sm">
								<div className="input-group-prepend">
									<label className="input-group-text">主题颜色</label>
								</div>
								<select name="color_pattern" className="form-control" onChange={this.changetheme.bind(this)}>
									<option value="SkyBlue">天蓝</option>
									<option value="Gray">灰色</option>
									<option value="LightGreen">青绿</option>
									<option value="DarkGreen">深绿</option>
									<option value="LightBlue">淡蓝</option>
									<option value="DarkBlue">深蓝</option>
									<option value="Orange">桔色</option>
									<option value="Purple">紫色</option>
									<option value="DarkRed">深红</option>
								</select>
								<button className="btn btn-primary btn-sm ml-3" onClick={() => me.actionSubmit()}> 生成报告 </button>
							</div>
						</div>
					</div>
					<div className="row py-3 bg-white">
						{
							roilist.length > 0 && roilist.map((r, index) => {
								//console.log(Object.getOwnPropertyNames(r)[0])
								let key = Object.getOwnPropertyNames(r)[0];
								let value = r[key];
								return (
									<p className="col-4 animated fadeInRight" key={index}><label className="list-group-item"> <input type="checkbox" value={key} onChange={() => me.checkroi(key)} /> {value} </label></p>
								)
							})
						}
					</div>
				</div>
				<div className="col-2  pl-0 pr-0">
					<Aside data={me.props.match.params} />
				</div>
			</div>

		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/t1/create_report.js